import { useCallback } from 'react'
import {
  useSchedulingWizard,
  rescheduleActionCreator,
} from '@user/components/Scheduling'
import type { UseData } from './useData'
import type { RowType } from '../../typings'

type Props = Pick<
  UseData,
  'setActiveDialog' | 'orderUrl' | 'locationUrl' | 'linkToOrder'
> & {
  row?: RowType
}

export function useHandlers(props: Props) {
  const { row, linkToOrder, orderUrl, locationUrl, setActiveDialog } = props

  const [, dispatch] = useSchedulingWizard()

  const onCancelClick = useCallback(
    () => setActiveDialog('cancel'),
    [setActiveDialog],
  )

  const onCompleteClick = useCallback(
    () => setActiveDialog('complete'),
    [setActiveDialog],
  )

  const onRescheduleClick = useCallback(() => {
    row && dispatch(rescheduleActionCreator(row))
  }, [dispatch, row])

  const onCloseDialog = useCallback(
    () => setActiveDialog(undefined),
    [setActiveDialog],
  )

  const onClickView = useCallback(
    () => window.open(linkToOrder ? orderUrl : locationUrl, '_blank'),
    [linkToOrder, locationUrl, orderUrl],
  )

  return {
    onClickView,
    onCloseDialog,
    onCancelClick,
    onCompleteClick,
    onRescheduleClick,
  }
}
